import React, { Component } from 'react';
import Header from "./Header";

import data2 from './data-news.json';
 
class News extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data2: data2,
};

}
  render() {
    return (

<div className="News">
<Header>
</Header>   
       
        <h2>News</h2>
        {data2.map(item =>
          <div>
          <h2>{item.Name}</h2>
          <h4>{item.Date}</h4>
            <span> 
            <img src={item.img} alt="snippet1"></img>
            <h3>{item.Desc}</h3>
            </span>
           <span> 
           <p>       
           <a>{item.Text}</a>
           </p>
           </span>
           </div>)
        } 
</div>
    );
  }
}
 
export default News;



// WEBPACK FOOTER //
// ./src/News.js